<div class="container">
    <div class="row justify-content-center">
        <div class="col-lg-6">
            <div class="text-center mt-4">
                <h1 class="display-1">500</h1>
                <p class="lead">{{ 'Internal Server Error' | t }}</p>
                <a href="../../../../#">
                    <i class="bi bi-arrow-left me-1"></i>
                    {{ 'Return to Home' | t }}
                </a>
            </div>
        </div>
    </div>
</div>
